export default __webpack_public_path__ + "static/media/Q14_3_resized.ebb66f6a.jpg";